import { render, staticRenderFns } from "./ReservationYearStats.vue?vue&type=template&id=628a5c56"
import script from "./ReservationYearStats.vue?vue&type=script&lang=js"
export * from "./ReservationYearStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports